module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-relax-taiguo.e2b7dfa1.png";